/**
 * The date-range buttons, shared by the Dashboard and the Daily page. `days` is what
 * rangeFor() (lib/format.ts) takes: positive = that many days ending yesterday,
 * negative = that single past day (-1 yesterday, -2 two days ago).
 */
export const RANGES = [
  { label: 'Yesterday', days: -1 },
  { label: '2d ago', days: -2 },
  { label: '7d', days: 7 },
  { label: '14d', days: 14 },
  { label: '30d', days: 30 },
  { label: '90d', days: 90 },
  { label: '1y', days: 365 },
];

export const DEFAULT_DAYS = 30;
